import { render } from "./ResendConfirmationEmail.vue?vue&type=template&id=24baa564"
import script from "./ResendConfirmationEmail.vue?vue&type=script&lang=js"
export * from "./ResendConfirmationEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__